<mat-dialog-content class="mat-typography">
    <h2>Croquis</h2>
    <form class="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full px-8" [formGroup]="croquisForm" (ngSubmit)="onFormSubmit()">
        <mat-form-field>
            <mat-label>Nom</mat-label>
            <input type="text" matInput formControlName="nom">
        </mat-form-field>

        <mat-form-field>
            <mat-label>Étage</mat-label>
            <mat-select matSelect formControlName="etage_id">
                <mat-option *ngFor="let etage of etages" [value]="etage.id">
                    {{etage.nom_niveau}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</mat-dialog-content>


<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="undefined">Annuler</button>
    <button type="submit" mat-flat-button (click)="onFormSubmit()" [color]="'primary'">Enregistrer</button>
</mat-dialog-actions>
